import { SxProps, Theme } from '@mui/material';

const styles = {

  contractValueContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },

  contractValueNote: {
    fontSize: 16,
    fontWeight: '600',
    color: 'grey.800',
  },

  padTop: { pt: '15px' },
  stackedBox: {
    mb: '12px',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
